var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-row",
    { attrs: { gutter: [16, 16], type: "flex", justify: "space-around" } },
    [
      _c(
        "a-col",
        { attrs: { span: 6 } },
        [
          _c("a-statistic", {
            attrs: { title: _vm.$t("lbl_tax_base_dpp"), value: _vm.baseAmount },
            scopedSlots: _vm._u([
              {
                key: "formatter",
                fn: function(ref) {
                  var value = ref.value
                  return [_vm._v(" " + _vm._s(_vm._f("currency")(value)) + " ")]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "a-col",
        { attrs: { span: 6 } },
        [
          _c("a-statistic", {
            attrs: { title: _vm.$t("lbl_sub_total"), value: _vm.subTotal },
            scopedSlots: _vm._u([
              {
                key: "formatter",
                fn: function(ref) {
                  var value = ref.value
                  return [_vm._v(" " + _vm._s(_vm._f("currency")(value)) + " ")]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "a-col",
        { attrs: { span: 6 } },
        [
          _c("a-statistic", {
            attrs: { title: _vm.$t("lbl_total_tax"), value: _vm.totalTax },
            scopedSlots: _vm._u([
              {
                key: "formatter",
                fn: function(ref) {
                  var value = ref.value
                  return [_vm._v(" " + _vm._s(_vm._f("currency")(value)) + " ")]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "a-col",
        { attrs: { span: 6 } },
        [
          _c("a-statistic", {
            attrs: { title: _vm.$t("lbl_total"), value: _vm.total },
            scopedSlots: _vm._u([
              {
                key: "formatter",
                fn: function(ref) {
                  var value = ref.value
                  return [_vm._v(" " + _vm._s(_vm._f("currency")(value)) + " ")]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }